import { render, staticRenderFns } from "./InstitutionManage.vue?vue&type=template&id=e69e7fca&scoped=true&"
import script from "./InstitutionManage.vue?vue&type=script&lang=js&"
export * from "./InstitutionManage.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionManage.vue?vue&type=style&index=0&id=e69e7fca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e69e7fca",
  null
  
)

export default component.exports